import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-target": "#course-trainnning-statistics",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Status Monitoring Report")
  ])
], -1)
const _hoisted_3 = {
  id: "course-trainnning-statistics",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = {
  class: "table table-borderless",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-right" }),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "All"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Active"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Inactive"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Suspended")
  ])
], -1)
const _hoisted_10 = {
  id: "institute",
  class: "border border-gray-400 text-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Training Institutes")
], -1)
const _hoisted_12 = {
  id: "trainer",
  class: "border border-gray-400 text-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Trainers")
], -1)
const _hoisted_14 = {
  id: "assessor",
  class: "border border-gray-400 text-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", { class: "text-right" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Assessors")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("tbody", null, null, -1)
const _hoisted_17 = { class: "mx-3" }
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_20 = {
  class: "col-md-12 mt-4 position-relative",
  id: "dataTable"
}
const _hoisted_21 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_22 = {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#courseTReport",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_23 = { class: "card-title m-0" }
const _hoisted_24 = { class: "fw-bolder m-0" }
const _hoisted_25 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_26 = { class: "collapse show" }
const _hoisted_27 = {
  class: "card-body border-top",
  style: {"overflow":"scroll"}
}
const _hoisted_28 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_36 = { class: "col-md-12 table-responsive sticky" }
const _hoisted_37 = {
  class: "table table-borderless instituteData",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " SL "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " IA / Govt. Org "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Institute Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Short Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Present Address "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Present City "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Upozila "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " District "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Division "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Training Capacity "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Phone "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Email "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "course",
      style: {"text-align":"center","font-weight":"bold !important"}
    }, " Web URL "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Status "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Tranche "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Course Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Batch No "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Training Start Date "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important","min-width":"15vw"} }, " Training End Date ")
  ])
], -1)
const _hoisted_39 = { style: {} }
const _hoisted_40 = { style: {"min-width":"10vw"} }
const _hoisted_41 = { style: {"min-width":"15vw"} }
const _hoisted_42 = { style: {"min-width":"10vw"} }
const _hoisted_43 = { style: {"min-width":"15vw"} }
const _hoisted_44 = { style: {"min-width":"10vw"} }
const _hoisted_45 = { style: {"min-width":"10vw"} }
const _hoisted_46 = { style: {"min-width":"10vw"} }
const _hoisted_47 = { style: {"min-width":"10vw"} }
const _hoisted_48 = { style: {"min-width":"10vw"} }
const _hoisted_49 = { style: {"min-width":"10vw"} }
const _hoisted_50 = { style: {"min-width":"10vw"} }
const _hoisted_51 = { style: {"min-width":"10vw"} }
const _hoisted_52 = ["href"]
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 2 }
const _hoisted_56 = { style: {"min-width":"10vw"} }
const _hoisted_57 = { style: {"min-width":"20vw"} }
const _hoisted_58 = { style: {"min-width":"15vw"} }
const _hoisted_59 = { style: {"min-width":"15vw"} }
const _hoisted_60 = { class: "mx-3" }
const _hoisted_61 = {
  key: 0,
  class: "row"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_63 = {
  class: "col-md-12 mt-4 position-relative",
  id: "dataTable"
}
const _hoisted_64 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_65 = {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#courseTReport",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_66 = { class: "card-title m-0" }
const _hoisted_67 = { class: "fw-bolder m-0" }
const _hoisted_68 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_69 = { class: "collapse show" }
const _hoisted_70 = {
  class: "card-body border-top",
  style: {"overflow":"scroll"}
}
const _hoisted_71 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_75 = [
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_79 = { class: "col-md-12 table-responsive sticky" }
const _hoisted_80 = {
  class: "table table-borderless trainerData",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_81 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " SL "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Trainer Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Status "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Is Guest Trainer? "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Gender "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Religion "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Mobile "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Email "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Associations "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Institutes "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Tranches "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "course",
      style: {"text-align":"center","font-weight":"bold !important"}
    }, " Courses "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Last Batch Number "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Last Batch Start Date "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Last Batch End Date "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Years of Experience ")
  ])
], -1)
const _hoisted_82 = { style: {} }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 1 }
const _hoisted_85 = { key: 2 }
const _hoisted_86 = { class: "commaSeparator" }
const _hoisted_87 = {
  key: 0,
  class: "commaSeparator"
}
const _hoisted_88 = { style: {"min-width":"25vw"} }
const _hoisted_89 = { key: 0 }
const _hoisted_90 = { style: {"min-width":"15vw"} }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { style: {"min-width":"40vw","width":"100px !important"} }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { style: {"min-width":"10vw"} }
const _hoisted_95 = { style: {"min-width":"10vw"} }
const _hoisted_96 = { style: {"min-width":"10vw"} }
const _hoisted_97 = { style: {"min-width":"10vw"} }
const _hoisted_98 = { class: "mx-3" }
const _hoisted_99 = {
  key: 0,
  class: "row"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" })
], -1)
const _hoisted_101 = {
  class: "col-md-12 mt-4 position-relative",
  id: "dataTable"
}
const _hoisted_102 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_103 = {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#courseTReport",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_104 = { class: "card-title m-0" }
const _hoisted_105 = { class: "fw-bolder m-0" }
const _hoisted_106 = {
  id: "courseTReport",
  class: "collapse show"
}
const _hoisted_107 = { class: "collapse show" }
const _hoisted_108 = {
  class: "card-body border-top",
  style: {"overflow":"scroll"}
}
const _hoisted_109 = {
  style: {"float":"right"},
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_115 = [
  _hoisted_114
]
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_117 = { class: "col-md-12 table-responsive sticky" }
const _hoisted_118 = {
  class: "table table-borderless assesorData",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"border-bottom":"1px solid #23ce10"} }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " SL "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Assesor Name "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Status "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Is Guest Trainer? "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Gender "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Religion "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Mobile "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Email "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Associations "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Institutes "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Tranches "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "course",
      style: {"text-align":"center","font-weight":"bold !important"}
    }, " Courses "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Last Batch Number "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Last Batch Start Date "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Last Batch End Date "),
    /*#__PURE__*/_createElementVNode("th", { style: {"text-align":"center","font-weight":"bold !important"} }, " Years of Experience ")
  ])
], -1)
const _hoisted_120 = { style: {} }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { key: 1 }
const _hoisted_123 = { key: 2 }
const _hoisted_124 = { class: "commaSeparator" }
const _hoisted_125 = {
  key: 0,
  class: "commaSeparator"
}
const _hoisted_126 = { style: {"min-width":"25vw"} }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { style: {"min-width":"15vw"} }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { style: {"min-width":"40vw","width":"100px !important"} }
const _hoisted_131 = { key: 0 }
const _hoisted_132 = { style: {"min-width":"10vw"} }
const _hoisted_133 = { style: {"min-width":"10vw"} }
const _hoisted_134 = { style: {"min-width":"10vw"} }
const _hoisted_135 = { style: {"min-width":"10vw"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.TrainningInstituteStatus('all')))
                    }, _toDisplayString(this.total_institute), 1),
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.TrainningInstituteStatus('active')))
                    }, _toDisplayString(this.active_institute), 1),
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.TrainningInstituteStatus('inactive')))
                    }, _toDisplayString(this.inactive_institute), 1),
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.TrainningInstituteStatus('suspend')))
                    }, _toDisplayString(this.suspend_institute), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.TrainerStatus('all')))
                    }, _toDisplayString(this.total_trainer), 1),
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.TrainerStatus('active')))
                    }, _toDisplayString(this.active_trainer), 1),
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.TrainerStatus('inactive')))
                    }, _toDisplayString(this.inactive_trainer), 1),
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.TrainerStatus('suspend')))
                    }, _toDisplayString(this.suspend_trainer), 1)
                  ]),
                  _createElementVNode("tr", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.AssesorStatus('all')))
                    }, _toDisplayString(this.total_assesor), 1),
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.AssesorStatus('active')))
                    }, _toDisplayString(this.active_assesor), 1),
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.AssesorStatus('inactive')))
                    }, _toDisplayString(this.inactive_assesor), 1),
                    _createElementVNode("td", {
                      class: "text-center",
                      style: {"cursor":"pointer","color":"blue"},
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.AssesorStatus('suspend')))
                    }, _toDisplayString(this.suspend_assesor), 1)
                  ])
                ]),
                _hoisted_16
              ])
            ])), [
              [_directive_loading, _ctx.load]
            ]),
            (_ctx.showInstitute)
              ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _createElementVNode("div", _hoisted_17, [
                    (_ctx.showInstitute)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("h3", _hoisted_24, " Institute Summary By Status (" + _toDisplayString(_ctx.status) + ")(Total:" + _toDisplayString(_ctx.instituteData.length) + ") ", 1)
                                ])
                              ]),
                              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                        title: "Download Xlse",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.exportTrainee()))
                                      }, _hoisted_30),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                        title: "Download PDF",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.downloadPdf()))
                                      }, _hoisted_32),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                        title: "Print",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.printPdf()))
                                      }, _hoisted_34),
                                      _hoisted_35
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                      _createElementVNode("table", _hoisted_37, [
                                        _hoisted_38,
                                        _createElementVNode("tbody", _hoisted_39, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.instituteData, (data, inx) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: inx,
                                              class: "border border-gray-400 text-center"
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(inx + 1), 1),
                                              _createElementVNode("td", _hoisted_40, _toDisplayString(data?.entities[0]?.entity_info
                                            ?.entity_short_name), 1),
                                              _createElementVNode("td", _hoisted_41, _toDisplayString(data?.institute_name), 1),
                                              _createElementVNode("td", _hoisted_42, _toDisplayString(data?.short_name), 1),
                                              _createElementVNode("td", _hoisted_43, _toDisplayString(data?.address), 1),
                                              _createElementVNode("td", _hoisted_44, _toDisplayString(data?.district_info?.district_name_eng), 1),
                                              _createElementVNode("td", _hoisted_45, _toDisplayString(data?.sub_district_info
                                            ?.upazila_name_eng), 1),
                                              _createElementVNode("td", _hoisted_46, _toDisplayString(data?.district_info?.district_name_eng), 1),
                                              _createElementVNode("td", _hoisted_47, _toDisplayString(data?.division_info?.division_name_eng), 1),
                                              _createElementVNode("td", _hoisted_48, _toDisplayString(data?.training_capacity), 1),
                                              _createElementVNode("td", _hoisted_49, _toDisplayString(data?.telephone), 1),
                                              _createElementVNode("td", _hoisted_50, _toDisplayString(data?.email), 1),
                                              _createElementVNode("td", _hoisted_51, [
                                                _createElementVNode("a", {
                                                  href: data?.web_url,
                                                  target: "_blank"
                                                }, _toDisplayString(data?.web_url), 9, _hoisted_52)
                                              ]),
                                              _createElementVNode("td", null, [
                                                (data.active_status == 1)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString('Active')))
                                                  : _createCommentVNode("", true),
                                                (data.active_status == 3)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString('Inactive')))
                                                  : _createCommentVNode("", true),
                                                (data.active_status == 4)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString('Suspend')))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_56, _toDisplayString(data?.last_batch_info[0]?.tranche_info
                                            ?.label), 1),
                                              _createElementVNode("td", _hoisted_57, _toDisplayString(data?.last_batch_info[0]?.course_info
                                            ?.course_name), 1),
                                              _createElementVNode("td", _hoisted_58, _toDisplayString(data?.last_batch_info[0]
                                            ?.batch_sequence_number), 1),
                                              _createElementVNode("td", _hoisted_59, _toDisplayString(data?.last_batch_info[0]?.start_date
                                            ? _ctx.moment(
                                                data?.last_batch_info[0]
                                                  ?.start_date
                                              ).format('DD-MM-YYYY')
                                            : ''), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])), [
                                [_directive_loading, _ctx.load]
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              : _createCommentVNode("", true),
            (_ctx.showTrainer)
              ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.trainerKey }, [
                  _createElementVNode("div", _hoisted_60, [
                    (_ctx.showTrainer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _hoisted_62,
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("div", _hoisted_66, [
                                  _createElementVNode("h3", _hoisted_67, " Trainer Summary By Status (" + _toDisplayString(_ctx.status) + ") (Total:" + _toDisplayString(_ctx.trainerData.length) + ") ", 1)
                                ])
                              ]),
                              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_68, [
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                        title: "Download Xlse",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.exportTraineeTwo()))
                                      }, _hoisted_73),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                        title: "Download PDF",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.downloadPdfTwo()))
                                      }, _hoisted_75),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                        title: "Print",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.printPdfTwo()))
                                      }, _hoisted_77),
                                      _hoisted_78
                                    ]),
                                    _createElementVNode("div", _hoisted_79, [
                                      _createElementVNode("table", _hoisted_80, [
                                        _hoisted_81,
                                        _createElementVNode("tbody", _hoisted_82, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.trainerData, (data, inx) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: inx,
                                              class: "border border-gray-400 text-center"
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(inx + 1), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.name), 1),
                                              _createElementVNode("td", null, [
                                                (data.active_status == 1)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString('Active')))
                                                  : _createCommentVNode("", true),
                                                (data.active_status == 3)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString('Inactive')))
                                                  : _createCommentVNode("", true),
                                                (data.active_status == 4)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString('Suspend')))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, _toDisplayString(data?.is_guest_trainer == 1
                                            ? 'Yes'
                                            : 'No'), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.gender), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.religion), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.mobile), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.email), 1),
                                              _createElementVNode("td", null, [
                                                (
                                            data &&
                                            data.map_entity_institute_course_trainer_entity_institute
                                          )
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([
                                              ...new Set(
                                                data.map_entity_institute_course_trainer_entity_institute.map(
                                                  (item) =>
                                                    item?.entity_info
                                                      ?.entity_short_name
                                                )
                                              ),
                                            ], (item, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        _createElementVNode("span", _hoisted_86, _toDisplayString(item), 1),
                                                        (
                                                index <
                                                [
                                                  ...new Set(
                                                    data.map_entity_institute_course_trainer_entity_institute.map(
                                                      (item) =>
                                                        item?.entity_info
                                                          ?.entity_short_name
                                                    )
                                                  ),
                                                ].length -
                                                  1
                                              )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_87, ", "))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_88, [
                                                (
                                            data &&
                                            data.map_entity_institute_course_trainer_entity_institute
                                          )
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([
                                              ...new Set(
                                                data.map_entity_institute_course_trainer_entity_institute.map(
                                                  (item) =>
                                                    item?.institute_info
                                                      ?.short_name
                                                )
                                              ),
                                            ], (item, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        _createElementVNode("span", null, _toDisplayString(item), 1),
                                                        (
                                                index <
                                                [
                                                  ...new Set(
                                                    data.map_entity_institute_course_trainer_entity_institute.map(
                                                      (item) =>
                                                        item?.institute_info
                                                          ?.short_name
                                                    )
                                                  ),
                                                ].length -
                                                  1
                                              )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_89, ", "))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_90, [
                                                (
                                            data &&
                                            data.map_entity_institute_course_trainer_entity_institute
                                          )
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([
                                              ...new Set(
                                                data.map_entity_institute_course_trainer_entity_institute.map(
                                                  (item) =>
                                                    item?.tranche_info
                                                      ?.short_name
                                                )
                                              ),
                                            ], (item, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        _createElementVNode("span", null, _toDisplayString(item), 1),
                                                        (
                                                index <
                                                [
                                                  ...new Set(
                                                    data.map_entity_institute_course_trainer_entity_institute.map(
                                                      (item) =>
                                                        item?.tranche_info
                                                          ?.short_name
                                                    )
                                                  ),
                                                ].length -
                                                  1
                                              )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_91, ", "))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_92, [
                                                (
                                            data &&
                                            data.map_entity_institute_course_trainer_course
                                          )
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([
                                              ...new Set(
                                                data.map_entity_institute_course_trainer_course.map(
                                                  (item) =>
                                                    item?.course_info
                                                      ?.course_name
                                                )
                                              ),
                                            ], (item, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        _createElementVNode("span", null, _toDisplayString(item), 1),
                                                        (
                                                index <
                                                [
                                                  ...new Set(
                                                    data.map_entity_institute_course_trainer_course.map(
                                                      (item) =>
                                                        item?.course_info
                                                          ?.course_name
                                                    )
                                                  ),
                                                ].length -
                                                  1
                                              )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_93, ", "))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_94, _toDisplayString(data
                                            ?.latest_batch_info_details_master_trainer
                                            ?.batch_info?.batch_sequence_number), 1),
                                              _createElementVNode("td", _hoisted_95, _toDisplayString(data
                                            ?.latest_batch_info_details_master_trainer
                                            ?.batch_info?.start_date
                                            ? _ctx.moment(
                                                data
                                                  ?.latest_batch_info_details_master_trainer
                                                  ?.batch_info?.start_date
                                              ).format('DD-MM-YYYY')
                                            : ''), 1),
                                              _createElementVNode("td", _hoisted_96, _toDisplayString(_ctx.FormData
                                            ?.latest_batch_info_details_master_trainer
                                            ?.batch_info?.end_date
                                            ? _ctx.moment(
                                                data
                                                  ?.latest_batch_info_details_master_trainer
                                                  ?.batch_info?.end_date
                                              ).format('DD-MM-YYYY')
                                            : ''), 1),
                                              _createElementVNode("td", _hoisted_97, _toDisplayString(data?.years_of_exp), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])), [
                                [_directive_loading, _ctx.load]
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              : _createCommentVNode("", true),
            (_ctx.showAssesor)
              ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.assesorKey }, [
                  _createElementVNode("div", _hoisted_98, [
                    (_ctx.showAssesor)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                          _hoisted_100,
                          _createElementVNode("div", _hoisted_101, [
                            _createElementVNode("div", _hoisted_102, [
                              _createElementVNode("div", _hoisted_103, [
                                _createElementVNode("div", _hoisted_104, [
                                  _createElementVNode("h3", _hoisted_105, " Assessor Summary By Status (" + _toDisplayString(_ctx.status) + ") (Total:" + _toDisplayString(_ctx.assesorData.length) + ") ", 1)
                                ])
                              ]),
                              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_106, [
                                _createElementVNode("div", _hoisted_107, [
                                  _createElementVNode("div", _hoisted_108, [
                                    _createElementVNode("div", _hoisted_109, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                        title: "Download Xlse",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.exportTraineeThree()))
                                      }, _hoisted_111),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                        title: "Download PDF",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.downloadPdfThree()))
                                      }, _hoisted_113),
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                        title: "Print",
                                        "data-v-54b12dc8": "",
                                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.printPdfThree()))
                                      }, _hoisted_115),
                                      _hoisted_116
                                    ]),
                                    _createElementVNode("div", _hoisted_117, [
                                      _createElementVNode("table", _hoisted_118, [
                                        _hoisted_119,
                                        _createElementVNode("tbody", _hoisted_120, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.assesorData, (data, inx) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: inx,
                                              class: "border border-gray-400 text-center"
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(inx + 1), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.name), 1),
                                              _createElementVNode("td", null, [
                                                (data.active_status == 1)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_121, _toDisplayString('Active')))
                                                  : _createCommentVNode("", true),
                                                (data.active_status == 3)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_122, _toDisplayString('Inactive')))
                                                  : _createCommentVNode("", true),
                                                (data.active_status == 4)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, _toDisplayString('Suspend')))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", null, _toDisplayString(data?.is_guest_trainer == 1
                                            ? 'Yes'
                                            : 'No'), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.gender), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.religion), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.mobile), 1),
                                              _createElementVNode("td", null, _toDisplayString(data?.employee_info?.email), 1),
                                              _createElementVNode("td", null, [
                                                (
                                            data &&
                                            data.map_entity_institute_course_assesor_entity_institute
                                          )
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([
                                              ...new Set(
                                                data.map_entity_institute_course_assesor_entity_institute.map(
                                                  (item) =>
                                                    item?.entity_info
                                                      ?.entity_short_name
                                                )
                                              ),
                                            ], (item, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        _createElementVNode("span", _hoisted_124, _toDisplayString(item), 1),
                                                        (
                                                index <
                                                [
                                                  ...new Set(
                                                    data.map_entity_institute_course_assesor_entity_institute.map(
                                                      (item) =>
                                                        item?.entity_info
                                                          ?.entity_short_name
                                                    )
                                                  ),
                                                ].length -
                                                  1
                                              )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_125, ", "))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_126, [
                                                (
                                            data &&
                                            data.map_entity_institute_course_assesor_entity_institute
                                          )
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([
                                              ...new Set(
                                                data.map_entity_institute_course_assesor_entity_institute.map(
                                                  (item) =>
                                                    item?.institute_info
                                                      ?.short_name
                                                )
                                              ),
                                            ], (item, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        _createElementVNode("span", null, _toDisplayString(item), 1),
                                                        (
                                                index <
                                                [
                                                  ...new Set(
                                                    data.map_entity_institute_course_assesor_entity_institute.map(
                                                      (item) =>
                                                        item?.institute_info
                                                          ?.short_name
                                                    )
                                                  ),
                                                ].length -
                                                  1
                                              )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_127, ", "))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_128, [
                                                (
                                            data &&
                                            data.map_entity_institute_course_assesor_entity_institute
                                          )
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([
                                              ...new Set(
                                                data.map_entity_institute_course_assesor_entity_institute.map(
                                                  (item) =>
                                                    item?.tranche_info
                                                      ?.short_name
                                                )
                                              ),
                                            ], (item, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        _createElementVNode("span", null, _toDisplayString(item), 1),
                                                        (
                                                index <
                                                [
                                                  ...new Set(
                                                    data.map_entity_institute_course_assesor_entity_institute.map(
                                                      (item) =>
                                                        item?.tranche_info
                                                          ?.short_name
                                                    )
                                                  ),
                                                ].length -
                                                  1
                                              )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_129, ", "))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_130, [
                                                (
                                            data &&
                                            data.map_entity_institute_course_assesor_course
                                          )
                                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList([
                                              ...new Set(
                                                data.map_entity_institute_course_assesor_course.map(
                                                  (item) =>
                                                    item?.course_info
                                                      ?.course_name
                                                )
                                              ),
                                            ], (item, index) => {
                                                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                        _createElementVNode("span", null, _toDisplayString(item), 1),
                                                        (
                                                index <
                                                [
                                                  ...new Set(
                                                    data.map_entity_institute_course_assesor_course.map(
                                                      (item) =>
                                                        item?.course_info
                                                          ?.course_name
                                                    )
                                                  ),
                                                ].length -
                                                  1
                                              )
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_131, ", "))
                                                          : _createCommentVNode("", true)
                                                      ], 64))
                                                    }), 128))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_132, _toDisplayString(data
                                            ?.latest_batch_info_details_master_assesor
                                            ?.batch_info?.batch_sequence_number), 1),
                                              _createElementVNode("td", _hoisted_133, _toDisplayString(data
                                            ?.latest_batch_info_details_master_assesor
                                            ?.batch_info?.start_date
                                            ? _ctx.moment(
                                                data
                                                  ?.latest_batch_info_details_master_assesor
                                                  ?.batch_info?.start_date
                                              ).format('DD-MM-YYYY')
                                            : ''), 1),
                                              _createElementVNode("td", _hoisted_134, _toDisplayString(_ctx.FormData
                                            ?.latest_batch_info_details_master_assesor
                                            ?.batch_info?.end_date
                                            ? _ctx.moment(
                                                data
                                                  ?.latest_batch_info_details_master_assesor
                                                  ?.batch_info?.end_date
                                              ).format('DD-MM-YYYY')
                                            : ''), 1),
                                              _createElementVNode("td", _hoisted_135, _toDisplayString(data?.years_of_exp), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])), [
                                [_directive_loading, _ctx.load]
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}